import axios from "axios";
import { GetLevels2 } from "./GetLevels2Action";
import {
  addLevel2Requested,
  addLevel2RequestSucceeded,
  addLevel2RequestFailed,
} from "../slices/AddLevel2Slice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Menu/AddLevel2`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const getSelectedCountryId = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData || !selectedCountry) {
    return null;
  }

  const session = JSON.parse(sessionData);
  const country = (session.rols || [])
    .map((entry) => entry.country)
    .find((item) => item?.countryName === selectedCountry);

  return country?.idcountry ?? null;
};

const getSessionUserName = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData) {
    return "";
  }

  const session = JSON.parse(sessionData);
  return session.employeeId || "";
};

export const AddLevel2 = (level2) => async (dispatch) => {
  try {
    dispatch(addLevel2Requested());

    const postData = {
      name: level2.name,
      isActive: level2.isActive ?? true,
      createdBy: getSessionUserName(),
      idLevel1: Number(level2.idLevel1),
      idCountry: Number(getSelectedCountryId()),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(apiUrl, postData, axiosConfig);

    if (response.data === true) {
      dispatch(addLevel2RequestSucceeded(response.data));
      await dispatch(GetLevels2());
      return { success: true, message: "Menu Level 2 created successfully" };
    }

    const errorMessage =
      "The menu level 2 could not be created. Please try again.";
    dispatch(addLevel2RequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(addLevel2RequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
